// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p8Ka7g1WAbDa7Z3DOjDG{align-items:center;display:flex;flex-direction:column;justify-content:center;margin-top:165px;text-align:center}.un0o2v1N361veegNXP1b{margin-right:5px}.ser6pH6MWleb38aZJ0CV{font-size:16px;margin-bottom:0;max-width:350px}.qJJaExBgYouTN31EyQkM{margin-bottom:45px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `p8Ka7g1WAbDa7Z3DOjDG`,
	"resetLink": `un0o2v1N361veegNXP1b`,
	"p": `ser6pH6MWleb38aZJ0CV`,
	"pLast": `qJJaExBgYouTN31EyQkM`
};
module.exports = ___CSS_LOADER_EXPORT___;
